import { API_URL } from '../config/connect';

const topUpUserBalance = async (userId, amount) => {
    const googleIdToken = localStorage.getItem("google_id_token");
    try {
        const response = await fetch(`${API_URL}/api/v1/admin/user/${userId}/top-up`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${googleIdToken}`,
            },
            body: JSON.stringify({ amount }),
        });
        if (!response.ok) {
            const errorBody = await response.json().catch(() => ({ message: response.statusText }));
            const detail = errorBody.detail;
            const errorMessage =
                (typeof detail === 'string' && detail) || detail?.[0]?.msg || errorBody.message || JSON.stringify(errorBody);
            const error = new Error(`Error ${response.status}: ${errorMessage}`);
            error.status = response.status;
            error.detail = errorMessage;
            throw error;
        }
        return await response.json();
    } catch (error) {
        console.error('Error topping up balance:', error);
        throw error;
    }
};

export default topUpUserBalance;


